export const BUTTON_STYLE = {
  flexShrink: 0,
  border: 'none',
  background: 'rgba(255,255,255,0.08)',
  color: 'rgba(255,255,255,0.75)',
  borderRadius: 8,
  padding: '4px 10px',
  fontSize: 12,
  fontWeight: 600,
  cursor: 'pointer',
};

export const STRIP_STYLE = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        margin: '0 12px 8px',
        padding: '8px 12px',
        borderRadius: 10,
        background: 'rgba(201, 168, 76, 0.12)',
        border: '1px solid rgba(201, 168, 76, 0.28)',
        color: 'rgba(255, 255, 255, 0.88)',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 1.35,
};
